"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const InputWidget_1 = tslib_1.__importDefault(require("../widget/InputWidget"));
const fmko_ts_common_1 = require("fmko-ts-common");
const KeyCode = tslib_1.__importStar(require("../../util/KeyboardEventCodes"));
/**
 * @deprecated Use {@link WCAGSearchField} instead.
 */
class SearchField extends InputWidget_1.default {
    constructor(element) {
        super(element, false);
        this.currentSelectionIndex = -1;
        this.minQueryLength = 2;
        this.isSuggestionFormatHtml = false;
        this.suggestionsList = document.createElement("ul");
        this.suggestionsList.className = "auto-suggest";
        this.suggestionsList.addEventListener("mousedown", (event) => {
            this.keepFocus = this.textFieldHasFocus;
        });
        this.suggestionsList.addEventListener("mouseup", (event) => {
            this.keepFocus = false;
        });
        this.suggestionsList.style.visibility = "hidden";
        this.showingSuggestions = false;
        const div = this.wrapInput();
        div.className = "auto-suggest-container";
        div.style.position = "relative";
        div.appendChild(this.suggestionsList);
        this.timer = new fmko_ts_common_1.FunctionalTimer(this.onTimerTriggered.bind(this));
        this.getInput().placeholder = "Søg ...";
    }
    addCssClass(...tokens) {
        this.getInput().classList.add(...tokens);
    }
    removeCssClass(...tokens) {
        this.getInput().classList.remove(...tokens);
    }
    toggleCssClass(token, force) {
        this.getInput().classList.toggle(token, force);
    }
    getValue() {
        return this.isOutOfSync() ? undefined : super.getValue();
    }
    isOutOfSync() {
        // Out-of-sync means: User has walked away from this widget with some text in the input field that doesn't match
        // the current value.
        return this.value && this.format(this.value) !== this.getInput().value;
    }
    formatSuggestion(suggestion) {
        return this.format(suggestion);
    }
    isShowingSuggestions() {
        return this.showingSuggestions;
    }
    addBlurHandler(handler) {
        if (!this.blurHandlers) {
            this.blurHandlers = [];
        }
        this.blurHandlers.push(handler);
    }
    getMinQueryLength() {
        return this.minQueryLength;
    }
    setMinQueryLength(minQueryLength) {
        this.minQueryLength = minQueryLength;
    }
    reset() {
        this.value = undefined;
        this.currentSelectionIndex = -1;
        this.currentHighlightIndex = -1;
        this.suggestions = null;
        this.moreSuggestions = false;
        this.getInput().value = "";
        this.textFieldValueStr = "";
    }
    getCurrentSelectionIndex() {
        return this.currentSelectionIndex;
    }
    hideSuggestions() {
        this.suggestionsList.style.visibility = "hidden";
        this.showingSuggestions = false;
        this.mouseDownItem = null;
    }
    decorateElement(element) {
        element.type = "text";
        element.classList.add("field", "searchField");
        element.addEventListener("keydown", (event) => {
            if (KeyCode.isEscape(event) && this.isShowingSuggestions()) {
                this.hideSuggestions();
                event.stopPropagation();
            }
        });
        element.addEventListener("keydown", this.handleOnKeyDown.bind(this));
        element.addEventListener("keyup", (event) => {
            const newValue = element.value;
            if (!this.textFieldValueStr || this.textFieldValueStr !== newValue) {
                this.textFieldValueStr = newValue;
                this.timer.schedule(SearchField.SEARCH_TIMER);
                this.onQueryStringChanged();
            }
        });
        element.addEventListener("blur", (event) => {
            this.textFieldHasFocus = false;
            if (this.keepFocus) {
                this.keepFocus = false;
                element.focus();
            }
            else {
                if (this.mouseDownItem) {
                    this.select(this.findElementIndex(this.suggestionsList.children, this.mouseDownItem));
                }
                if (this.isShowingSuggestions()) {
                    this.hideSuggestions();
                    if (this.suggestions && this.suggestions.length === 1) {
                        this.select(0);
                    }
                }
                if (this.blurHandlers) {
                    for (let h of this.blurHandlers) {
                        h(event);
                    }
                }
                if (this.isOutOfSync()) {
                    this.setValue(undefined, true);
                }
            }
        });
        element.addEventListener("focus", (event) => {
            this.textFieldHasFocus = true;
            const value = element.value;
            if (value && value.length > 0) {
                element.select();
            }
        });
    }
    onQueryStringChanged() {
        return null;
    }
    populateSuggestions(suggestions, showSuggestions, moreSuggestions = false) {
        this.suggestions = suggestions;
        this.moreSuggestions = moreSuggestions;
        if (this.isVisible() && this.isAttached(this.element)) {
            // Clear current suggestions
            this.suggestionsList.innerHTML = "";
            this.currentSelectionIndex = -1;
            this.currentHighlightIndex = -1;
            this.mouseDownItem = null;
            if (moreSuggestions) {
                const hint = document.createElement("li");
                hint.className = "hint first";
                hint.innerText = "Viser ikke alle - præcisér din søgning";
                this.suggestionsList.appendChild(hint);
            }
            let i = 0;
            for (let suggestion of suggestions) {
                const li = document.createElement("li");
                if (i % 2 === 0) {
                    li.className = "even";
                }
                if (i === 0 && !moreSuggestions) {
                    li.className += " first";
                }
                if (i === suggestions.length - 1) {
                    li.className += " last";
                }
                if (this.isSuggestionFormatHtml) {
                    fmko_ts_common_1.HTMLUtils.setSanitizedHTML(li, this.formatSuggestion(suggestion));
                }
                else {
                    fmko_ts_common_1.HTMLUtils.setSanitizedHTML(li, this.formatSuggestion(suggestion));
                }
                this.suggestionsList.appendChild(li);
                li.addEventListener("mousedown", (event) => {
                    this.mouseDownItem = li;
                });
                li.addEventListener("mouseup", (event) => {
                    this.handleMouseUp(li, event);
                });
                // Make sure we pass "i" in at the right time - wrap in a function to evaluate value of "i" immediately!
                const suggestBox = this;
                (function (ii) {
                    li.addEventListener("mouseover", (event) => {
                        let highlightIndex = ii;
                        if (moreSuggestions) {
                            highlightIndex += 1;
                        }
                        suggestBox.highlight(highlightIndex);
                    });
                })(i++);
            }
            if (showSuggestions && suggestions.length > 0) {
                this.showSuggestions();
            }
        }
    }
    parseValueFromInput(value) {
        // Not used, hence always return null to keep TS-compiler happy!
        return null;
    }
    setValueOnInput(newValue, input) {
        if (!newValue) {
            this.getInput().value = "";
        }
        else if (this.suggestions && this.suggestions.indexOf(newValue) > -1) {
            this.currentSelectionIndex = this.suggestions.indexOf(newValue);
            this.textFieldValueStr = this.format(newValue);
            this.getInput().value = this.textFieldValueStr;
            this.highlight(this.currentSelectionIndex);
        }
        else {
            this.populateSuggestions([newValue], false, false);
            this.currentSelectionIndex = 0;
            this.textFieldValueStr = this.format(newValue);
            this.getInput().value = this.textFieldValueStr;
        }
    }
    onTimerTriggered() {
        const query = this.getInput().value;
        if (query.length < this.minQueryLength) {
            this.populateSuggestions([], false, false);
        }
        else {
            this.search(query);
        }
    }
    handleOnKeyDown(event) {
        if (!this.anyModifierKeys(event)) {
            let previousSelectionIndex;
            if (KeyCode.isArrowDown(event)) {
                if (!this.isShowingSuggestions()) {
                    if (this.currentHighlightIndex === -1 && this.suggestions.length > 0) {
                        this.highlight(0);
                    }
                    this.showSuggestions();
                }
                else {
                    if (this.currentHighlightIndex !== -1) {
                        if (this.currentHighlightIndex === this.suggestions.length - 1) {
                            previousSelectionIndex = 0;
                        }
                        else {
                            previousSelectionIndex = this.currentHighlightIndex + 1;
                        }
                    }
                    else if (this.suggestions.length > 0) {
                        previousSelectionIndex = 0;
                    }
                    else {
                        previousSelectionIndex = -1;
                    }
                    this.highlight(previousSelectionIndex);
                    this.scrollIntoView(previousSelectionIndex);
                }
            }
            else if (KeyCode.isArrowUp(event)) {
                if (!this.isShowingSuggestions()) {
                    if (this.currentHighlightIndex === -1 && this.suggestions.length > 0) {
                        this.highlight(this.suggestions.length - 1);
                    }
                    this.showSuggestions();
                }
                else {
                    if (this.currentHighlightIndex !== -1) {
                        if (this.currentHighlightIndex === 0) {
                            previousSelectionIndex = this.suggestions.length - 1;
                        }
                        else {
                            previousSelectionIndex = this.currentHighlightIndex - 1;
                        }
                    }
                    else if (this.suggestions.length > 0) {
                        previousSelectionIndex = this.suggestions.length - 1;
                    }
                    else {
                        previousSelectionIndex = -1;
                    }
                    this.highlight(previousSelectionIndex);
                    this.scrollIntoView(previousSelectionIndex);
                }
            }
            else if (KeyCode.isEnter(event)) {
                if (this.isShowingSuggestions()) {
                    if (this.currentHighlightIndex !== -1) {
                        this.hideSuggestions();
                        this.select(this.currentHighlightIndex);
                    }
                    else if (this.suggestions != null && this.suggestions.length === 1) {
                        this.hideSuggestions();
                        this.select(0);
                    }
                }
            }
            else if (KeyCode.isEscape(event) && this.isShowingSuggestions()) {
                this.hideSuggestions();
                event.preventDefault();
                event.stopPropagation();
            }
        }
    }
    select(selectionIndex) {
        if (this.currentSelectionIndex !== selectionIndex) {
            if (this.moreSuggestions) {
                selectionIndex -= 1;
            }
            const newValue = selectionIndex === -1 ? null : this.suggestions[selectionIndex];
            this.setValue(newValue, true);
        }
    }
    findElementIndex(children, item) {
        for (let i = 0; i < children.length; i++) {
            if (item === children[i]) {
                return i;
            }
        }
        return -1;
    }
    anyModifierKeys(e) {
        return e.altKey || e.ctrlKey || e.metaKey || e.shiftKey;
    }
    handleMouseUp(li, event) {
        this.highlight(this.findElementIndex(this.suggestionsList.children, li));
        if (this.isShowingSuggestions() && this.currentHighlightIndex !== -1) {
            this.hideSuggestions();
            this.select(this.currentHighlightIndex);
        }
    }
    scrollIntoView(index) {
        if (index !== -1) {
            const element = this.suggestionsList.children.item(index);
            const elementHeight = element.getBoundingClientRect().height;
            const scrollTo = elementHeight * index;
            const listTop = this.suggestionsList.scrollTop;
            const listHeight = this.suggestionsList.clientHeight;
            const listBottom = listTop + listHeight;
            if (scrollTo < listTop) {
                this.suggestionsList.scrollTop = scrollTo;
            }
            const halfAnElement = elementHeight / 2;
            if (scrollTo >= (listBottom - halfAnElement)) {
                this.suggestionsList.scrollTop = (scrollTo + elementHeight) - listHeight;
            }
        }
    }
    showSuggestions() {
        this.suggestionsList.style.visibility = "visible";
        this.showingSuggestions = true;
    }
    highlight(newIndex) {
        if (this.currentHighlightIndex !== newIndex) {
            if (this.currentHighlightIndex !== -1) {
                const el = this.suggestionsList.children.item(this.currentHighlightIndex);
                el.classList.remove("hover");
            }
            this.currentHighlightIndex = newIndex;
            if (this.currentHighlightIndex !== -1) {
                const el = this.suggestionsList.children.item(this.currentHighlightIndex);
                el.classList.add("hover");
            }
        }
    }
}
SearchField.SEARCH_TIMER = 400;
exports.default = SearchField;
//# sourceMappingURL=SearchField.js.map